import type { ReactNode } from 'react'

/**
 * Shared question layout (PLAN-Z M4): prompt area, answer area, submit.
 * Both text subtests (and later the figure subtest) render inside this card.
 */
interface QuestionCardProps {
  title?: string
  prompt: ReactNode
  answer: ReactNode
  onSubmit: () => void
  submitDisabled?: boolean
  submitLabel?: string
  feedback?: ReactNode
}

export function QuestionCard({
  title,
  prompt,
  answer,
  onSubmit,
  submitDisabled = false,
  submitLabel = 'Submit',
  feedback,
}: QuestionCardProps) {
  return (
    <section className="question-card">
      {title ? <h2 className="question-card-title">{title}</h2> : null}
      <div className="question-prompt">{prompt}</div>
      <div className="question-answer">{answer}</div>
      <button
        type="button"
        className="question-submit"
        onClick={onSubmit}
        disabled={submitDisabled}
      >
        {submitLabel}
      </button>
      {feedback ? <div className="question-feedback">{feedback}</div> : null}
    </section>
  )
}
